interface Props {
  className?: string;
  checked: boolean;
}

const SquareCheckBox = (props: Props) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.5}
        y={0.5}
        width={17}
        height={17}
        rx={2.5}
        fill="#fff"
        stroke="#2A2A2A"
      />
      {props.checked && (
        <path
          d="M7.952 12.865a.459.459 0 01-.65 0l-2.6-2.6a.69.69 0 010-.975l.326-.326a.69.69 0 01.976 0l1.623 1.623 4.384-4.385a.69.69 0 01.976 0l.326.326a.69.69 0 010 .976l-5.361 5.361z"
          fill="#2A2A2A"
        />
      )}
    </svg>
  );
};

export default SquareCheckBox;
